import React from "react";
import { getCompanyBranding } from "../lib/site";
import logo from "../assets/logo.png";

const VARIANTS = {
  light: {
    name: "text-[#0b1f3a] group-hover:text-[#1758a8]",
    tagline: "text-[#1e6fcf] group-hover:text-[#1758a8]",
    divider: "via-slate-200",
    glow: "group-hover:bg-[#1e6fcf]/10",
  },
  dark: {
    name: "text-white group-hover:text-[#aad4fa]",
    tagline: "text-[#aad4fa]/90 group-hover:text-[#aad4fa]",
    divider: "via-white/20",
    glow: "group-hover:bg-white/10",
  },
};

function BrandText({ shortName, legalSuffix, tagline, styles, variant }) {
  return (
    <div className="flex flex-col justify-center min-w-0 leading-tight">
      <span className={`font-extrabold text-sm md:text-[15px] tracking-tight transition-colors duration-200 ${styles.name}`}>
        {shortName}
      </span>
      {legalSuffix && (
        <span className={`font-extrabold text-sm md:text-[15px] tracking-tight transition-colors duration-200 ${styles.name}`}>
          {legalSuffix}
        </span>
      )}
      {tagline && (
        <>
          <span
            className={`my-1 h-px w-full max-w-[220px] bg-gradient-to-r ${
              variant === "dark"
                ? "from-[#1e6fcf]/80 via-[#aad4fa]/40 to-transparent"
                : "from-[#1e6fcf] via-[#f59e0b]/60 to-transparent"
            }`}
            aria-hidden="true"
          />
          <span
            className={`text-[9px] md:text-[10px] lg:text-[11px] font-medium italic tracking-wide whitespace-nowrap transition-colors duration-200 ${styles.tagline}`}
          >
            {tagline}
          </span>
        </>
      )}
    </div>
  );
}

export default function BrandLockup({
  about = {},
  variant = "light",
  className = "",
  showDivider = true,
  logoClassName = "h-12 w-auto",
  alwaysShowText = false,
  hideTagline = false,
}) {
  const { shortName, legalName, tagline, legalSuffix } = getCompanyBranding(about);
  const displayTagline = hideTagline ? "" : tagline;
  const styles = VARIANTS[variant] || VARIANTS.light;

  return (
    <div className={`flex items-center gap-3 sm:gap-3.5 min-w-0 ${className}`}>
      <div className="relative flex-shrink-0">
        <div
          className={`absolute -inset-2 rounded-xl transition-colors duration-300 ${styles.glow}`}
          aria-hidden="true"
        />
        <img
          src={logo}
          alt=""
          className={`relative block object-contain ${logoClassName}`}
          aria-hidden="true"
        />
      </div>

      {showDivider && (
        <div
          className={`${alwaysShowText ? "block" : "hidden sm:block"} w-px h-12 bg-gradient-to-b from-transparent ${styles.divider} to-transparent flex-shrink-0`}
          aria-hidden="true"
        />
      )}

      <div className={alwaysShowText ? "flex min-w-0 overflow-visible" : "hidden sm:flex min-w-0 overflow-visible"}>
        <BrandText
          shortName={shortName}
          legalSuffix={legalSuffix}
          tagline={displayTagline}
          styles={styles}
          variant={variant}
        />
      </div>

      <span className="sr-only">{legalName}</span>
    </div>
  );
}
